import { useEffect, useState } from "react";
import api from "api/api";
import { useNavigate } from "react-router-dom";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import RadioGroup from "@mui/material/RadioGroup";

// import mui icons
import TuneIcon from "@mui/icons-material/Tune";
import IconButton from "@mui/material/IconButton";
import AutoGraphRoundedIcon from "@mui/icons-material/AutoGraphRounded";
import CloseIcon from "@mui/icons-material/Close";

//import assets
import brandImg from "../../assets/brands.png";
import calendarImg from "../../assets/calendar.jpg";
import countryImg from "../../assets/country.jpeg";
import competitorImg from "../../assets/competitor.png";
import studyTypeImg from "../../assets/study-type.png";
import studyTypeMethodImg from "../../assets/study-type-method.png";
import blindImg from "../../assets/blind-img.png";
import cbpImg from "../../assets/cbp-img.png";
import forwardPng from "../../assets/forward.png";
import moveIcon from "../../assets/icons/moveIcon.png";
import matchNet from "../../assets/icons/matchNet.png";
import { Radio } from "@mui/material";

import ReactCountryFlag from "react-country-flag";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { loadStudyPageFiltersState, loadStudyPageSelectAllFiltersState, loadStudyFiltersFlagState, loadSelectAllStudyFiltersFlagState, loadSearchBarTextState } from "store/features/studyDataSlice";
import { loadSelectedStudyTypeState } from "store/features/matchNetSlice";
import { showNotification } from "store/features/notificationSlice";
import { resetMatchNetStoreState } from "store/features/matchNetSlice";

const filtersLabel = [
    {
        label: "Study Type",
        image: studyTypeImg,
        value: "studyType",
    },
    {
        label: "Blind/Branded/Full Mix",
        image: blindImg,
        value: "Blind/Branded/Full Mix",
    },
    {
        label: "CBP",
        image: cbpImg,
        value: "CBP",
    },
    {
        label: "Study Type Method",
        image: studyTypeMethodImg,
        value: "studyTypeMethod",
    },
    {
        label: "Country",
        image: countryImg,
        value: "country",
    },
    {
        label: "Unilever Brand",
        image: brandImg,
        value: "unileverBrand",
    },
    {
        label: "Product Format",
        image: competitorImg,
        value: "deodorantFormat",
    },
    {
        label: "Study Period",
        image: calendarImg,
        value: "studyPeriod",
    },
];

function StudiesFiltersComponent({ handleFiltersSubmit = () => {}, studiesRoute = "", defaultOpen = true }) {
    const dispatch = useDispatch();
    const theme = useTheme();
    const navigate = useNavigate();
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const productCategoryId = productCategoryData?.value || null;

    const studyPageFilters = useSelector((state) => state.studyDataStore.studyPageFilters);
    const studyPageSelectAllFilters = useSelector((state) => state.studyDataStore.studyPageSelectAllFilters);
    const studyFiltersFlag = useSelector((state) => state.studyDataStore.studyFiltersFlag);
    const selectAllStudyFiltersFlag = useSelector((state) => state.studyDataStore.selectAllStudyFiltersFlag);
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isBeautyAndWellbeing = isHairCare || isSkinCare;
    const isDeodorants = process.env?.REACT_APP_DEODORANTS?.toLowerCase() === productCategoryData?.label?.toLowerCase();

    // filters value state --- --- assign default empty [] if data is not present in global context
    const [filtersValue, setFiltersValue] = useState({
        studyType: studyPageFilters && studyPageFilters.studyType !== undefined ? studyPageFilters.studyType : [],
        ...(isHairCare && {
            "Blind/Branded/Full Mix": studyPageFilters?.["Blind/Branded/Full Mix"] || [],
            CBP: studyPageFilters?.CBP || [],
        }),
        ...(isSkinCare && {
            "Blind/Branded/Full Mix": studyPageFilters?.["Blind/Branded/Full Mix"] || [],
        }),
        studyTypeMethod: studyPageFilters && studyPageFilters.studyTypeMethod !== undefined ? studyPageFilters.studyTypeMethod : [],
        country: studyPageFilters && studyPageFilters.country !== undefined ? studyPageFilters.country : [],
        unileverBrand: studyPageFilters && studyPageFilters.unileverBrand !== undefined ? studyPageFilters.unileverBrand : [],
        deodorantFormat: studyPageFilters && studyPageFilters.deodorantFormat !== undefined ? studyPageFilters.deodorantFormat : [],
        studyPeriod: studyPageFilters && studyPageFilters.studyPeriod !== undefined ? studyPageFilters.studyPeriod : [],
    });

    //selectAll value state --- assign default value FALSE if data is not present in global context
    const [selectAllChecked, setSelectAllChecked] = useState({
        studyType: studyPageSelectAllFilters && studyPageSelectAllFilters.studyType !== undefined ? studyPageSelectAllFilters.studyType : false,
        ...(isHairCare && {
            "Blind/Branded/Full Mix": studyPageSelectAllFilters?.["Blind/Branded/Full Mix"] ?? false,
             CBP: studyPageSelectAllFilters?.CBP ?? false,
        }),
        ...(isSkinCare && {
            "Blind/Branded/Full Mix": studyPageSelectAllFilters?.["Blind/Branded/Full Mix"] ?? false,
         }),
        studyTypeMethod: studyPageSelectAllFilters && studyPageSelectAllFilters.studyTypeMethod !== undefined ? studyPageSelectAllFilters.studyTypeMethod : false,
        country: studyPageSelectAllFilters && studyPageSelectAllFilters.country !== undefined ? studyPageSelectAllFilters.country : false,
        unileverBrand: studyPageSelectAllFilters && studyPageSelectAllFilters.unileverBrand !== undefined ? studyPageSelectAllFilters.unileverBrand : false,
        deodorantFormat: studyPageSelectAllFilters && studyPageSelectAllFilters.deodorantFormat !== undefined ? studyPageSelectAllFilters.deodorantFormat : false,
        studyPeriod: studyPageSelectAllFilters && studyPageSelectAllFilters.studyPeriod !== undefined ? studyPageSelectAllFilters.studyPeriod : false,
    });

    const [filterOptions, setFilterOptions] = useState({
        studyType: [],
        ...(isHairCare && {
            "Blind/Branded/Full Mix": [],
            CBP: [],
        }),
        ...(isSkinCare && {
            "Blind/Branded/Full Mix": [],
        }),
        studyTypeMethod: [],
        unileverBrand: [],
        country: [],
        studyPeriod: [],
        deodorantFormat: [],
    });

    const [selectedFilter, setSelectedFilter] = useState("studyType");
    const [disableMoveIcon, setDisableMoveIcon] = useState(true);
    const [matchingNetDataAvailable, setMatchingNetDataAvailable] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [selectedContext, setSelectedContext] = useState("");

    const handleDialogToggle = () => {
        setShowDialog((prev) => !prev);
        setSelectedContext("");
    };

    const [openFilter, setOpenFilter] = useState(defaultOpen);
    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setOpenFilter(open);
    };

    useEffect(() => {
        const selectAllStudyFilters = Object.values(selectAllChecked).every((value) => value === true);
        if (selectAllStudyFilters) {
            dispatch(loadSelectAllStudyFiltersFlagState(true));
        } else {
            dispatch(loadSelectAllStudyFiltersFlagState(false));
        }
    }, [selectAllChecked]);

    const navigateTo = (route) => {
        navigate(route);
    };

    const handleFilters = () => {
        setOpenFilter(false);
        if (studiesRoute) {
            dispatch(loadStudyFiltersFlagState(false));
            navigateTo(studiesRoute);
            return;
        }
        handleFiltersSubmit();
    };

    const getFilterQueryString = (filtersLabel) => {
        let queryString = "";

        if (productCategoryId) {
            let _queryString = `product_category=${productCategoryId}`;
            if (filtersValue && Object.keys(filtersValue).length > 0) {
                filtersLabel.forEach((filter) => {
                    if (!isBeautyAndWellbeing && (filter === "Blind/Branded/Full Mix" || filter === "CBP")) return;
                    let checkedValue = "";
                    let _filter = filter;
                    filtersValue[_filter]?.forEach((datum) => {
                        if (datum.checked) {
                            if (checkedValue !== "") {
                                checkedValue += ",";
                            }
                            checkedValue += datum.value;
                        }
                    });
                    if (checkedValue !== "") {
                        if (_queryString !== "") {
                            _queryString += "&";
                        }

                        if (_filter === "deodorantFormat") {
                            _filter = "deodorant_format";
                        } else if (_filter === "studyPeriod") {
                            _filter = "study_period";
                        } else if (_filter === "unileverBrand") {
                            _filter = "unilever_brand";
                        } else if (_filter === "country") {
                            _filter = "country";
                        } else if (_filter === "studyType") {
                            _filter = "study_type";
                        } else if (_filter === "Blind/Branded/Full Mix") {
                            _filter = "blind_branded";
                        } else if (_filter === "CBP") {
                            _filter = "consumer_benefit_platform";
                        } else if (_filter === "studyTypeMethod") {
                            _filter = "study_type_method";
                        } else {
                            _filter = "";
                        }
                        _queryString += _filter + "=" + checkedValue;
                    }
                });
            }
            queryString = _queryString;
        }
        return queryString;
    };

    const getOptionArrayAndUpdateFilterValue = (resData, _filtersValue, identifier) => {
        const mappedArray = mapDataToOptions(resData, false);

        let datum = _filtersValue;
        let array = getOptionsArray(mappedArray, _filtersValue, identifier);

        if (identifier === "studyType") {
            array = array.sort((a, b) => b.label.localeCompare(a.label));
        } else if (identifier === "studyTypeMethod") {
            array = array.sort((a, b) => {
                // Sort by studyTypeTitle first
                if (a.studyTypeTitle < b.studyTypeTitle) return 1;
                if (a.studyTypeTitle > b.studyTypeTitle) return -1;

                // If studyTypeTitle is the same, sort by label alphabetically
                if (a.label < b.label) return -1;
                if (a.label > b.label) return 1;

                return 0;
            });
        }

        datum[identifier] = [...array];
        setFiltersValue((pre) => {
            return {
                ...pre,
                ...datum,
            };
        });
        setFilterOptions((prev) => ({
            ...prev,
            [identifier]: [...array], // update only the key you need
        }));
        syncAllIdentifiersSelectAll({ ...datum });
    };

    const getOptionsArray = (mappedArray, filtersValue, identifier) => {
        let array = [];

        mappedArray.forEach((item) => {
            const data = filtersValue[identifier]?.find((ele) => ele.label === item.label && ele.value === item.value);
            if (data) {
                array.push({ ...item, checked: data.checked });
            } else {
                array.push(item);
            }
        });

        return array;
    };

    const mapDataToOptions = (data, isChecked) => {
        return data?.map((datum) => {
            if (isBeautyAndWellbeing && typeof datum === "string") {
                return {
                    description: datum,
                    value: datum,
                    label: datum,
                    checked: isChecked,
                };
            }
            return {
                description: datum.description,
                value: datum.id,
                label: datum.title,
                studyTypeTitle: datum?.study_type__title || "",
                checked: isChecked,
            };
        });
    };
    async function fetchBlindBrandedFullMixData() {
        try {
            const queryString = getFilterQueryString(["studyType"]);
            const url = process.env.REACT_APP_SERVER_PATH + `/study-datas/blind-branded/?${queryString}`;

            const res = await api.get(url);
            getOptionArrayAndUpdateFilterValue(res.data, filtersValue, "Blind/Branded/Full Mix");
        } catch (error) {
            handleError("error", error);
        }
    }
    async function fetchCBPData() {
        try {
            const queryString = getFilterQueryString(["studyType", "Blind/Branded/Full Mix"]);
            const url = process.env.REACT_APP_SERVER_PATH + `/study-datas/consumer-benefit-platform/?${queryString}`;

            const res = await api.get(url);
            getOptionArrayAndUpdateFilterValue(res.data, filtersValue, "CBP");
        } catch (error) {
            handleError("error", error);
        }
    }

    async function fetchStudyTypeMethodData() {
        try {
            const queryString = getFilterQueryString(["studyType", "Blind/Branded/Full Mix", "CBP"]);
            const url = process.env.REACT_APP_SERVER_PATH + `/core-data-models/study-type-method/?${queryString}`;
            await api
                .get(url)
                .then(async (res) => {
                    getOptionArrayAndUpdateFilterValue(res.data, filtersValue, "studyTypeMethod");
                })
                .catch(async (error) => {
                    handleError("error", error);
                });
        } catch (error) {
            handleError("error", error);
        }
    }

    async function fetchCountryData() {
        try {
            const queryString = getFilterQueryString(["studyType", "Blind/Branded/Full Mix", "CBP", "studyTypeMethod"]);
            const url = process.env.REACT_APP_SERVER_PATH + `/core-data-models/country/?${queryString}`;
            await api
                .get(url)
                .then(async (res) => {
                    getOptionArrayAndUpdateFilterValue(res.data, filtersValue, "country");
                })
                .catch(async (error) => {
                    handleError("error", error);
                });
        } catch (error) {
            handleError("error", error);
        }
    }

    async function fetchUnileverBrandData() {
        try {
            const queryString = getFilterQueryString(["studyType", "Blind/Branded/Full Mix", "CBP", "studyTypeMethod", "country"]);
            const url = process.env.REACT_APP_SERVER_PATH + `/core-data-models/unilever-brand/?${queryString}`;
            await api
                .get(url)
                .then(async (res) => {
                    getOptionArrayAndUpdateFilterValue(res.data, filtersValue, "unileverBrand");
                })
                .catch(async (error) => {
                    handleError("error", error);
                });
        } catch (error) {
            handleError("error", error);
        }
    }

    async function fetchDeodorantFormatData() {
        try {
            const queryString = getFilterQueryString(["studyType", "Blind/Branded/Full Mix", "CBP", "studyTypeMethod", "country", "unileverBrand"]);
            const url = process.env.REACT_APP_SERVER_PATH + `/core-data-models/deodorant-format/?${queryString}`;
            await api
                .get(url)
                .then(async (res) => {
                    getOptionArrayAndUpdateFilterValue(res.data, filtersValue, "deodorantFormat");
                })
                .catch(async (error) => {
                    handleError("error", error);
                });
        } catch (error) {
            handleError("error", error);
        }
    }

    async function fetchStudyPeriod() {
        try {
            const queryString = getFilterQueryString(["studyType", "Blind/Branded/Full Mix", "CBP", "studyTypeMethod", "country", "deodorantFormat", "unileverBrand"]);
            const url = `${process.env.REACT_APP_SERVER_PATH}/core-data-models/study-period/?${queryString}`;
            await api
                .get(url)
                .then(async (res) => {
                    getOptionArrayAndUpdateFilterValue(res.data, filtersValue, "studyPeriod");
                })
                .catch(async (error) => {
                    handleError("error", error);
                });
        } catch (error) {
            handleError("error", error);
        }
    }

    useEffect(() => {
        async function fetchStudyTypeData() {
            if (productCategoryId) {
                try {
                    const url = process.env.REACT_APP_SERVER_PATH + `/core-data-models/study-type/?product_category=${productCategoryId}`;
                    api.get(url)
                        .then(async (res) => {
                            getOptionArrayAndUpdateFilterValue(res.data, filtersValue, "studyType");
                        })
                        .catch(async (error) => {
                            handleError("error", error);
                        });
                } catch (error) {
                    handleError("error", error);
                }
            }
        }
        fetchStudyTypeData();
        // Beauty & Wellbeing (Hair Care + Skin Care)
        if (isBeautyAndWellbeing) {
            fetchBlindBrandedFullMixData();
        }
        // Only Hair Care
        if (isHairCare) {
            fetchCBPData();
        }
        fetchStudyTypeMethodData();
        fetchCountryData();
        fetchUnileverBrandData();
        fetchDeodorantFormatData();
        fetchStudyPeriod();
    }, [productCategoryId]);

    useEffect(() => {
        if (filtersValue && filtersValue?.studyType && filtersValue?.studyPeriod.length !== 0 && filtersValue?.studyPeriod.some((ele) => ele.checked === true)) {
            setDisableMoveIcon(false);
        } else {
            dispatch(loadStudyFiltersFlagState(true));
            setDisableMoveIcon(true);
        }
    }, [filtersValue]);

    useEffect(() => {
        if (studyFiltersFlag === false) {
            setOpenFilter(false);
            handleFiltersSubmit();
        }
    }, []);

    const getQueryString = () => {
        let queryString = productCategoryId ? `product_category=${productCategoryId}` : "";
        if (Object.keys(studyPageFilters).length > 0 && studyPageFilters && Object.keys(studyPageFilters).length > 0) {
            Object.keys(studyPageFilters).forEach((filter) => {
                let checkedValue = "";
                let _filter = filter;
                studyPageFilters[_filter].forEach((datum) => {
                    if (datum.checked) {
                        if (checkedValue !== "") {
                            checkedValue += ",";
                        }
                        if (_filter === "studyPeriod") {
                            checkedValue += datum.label;
                        } else {
                            checkedValue += datum.value;
                        }
                    }
                });
                if (checkedValue !== "") {
                    if (queryString !== "") {
                        queryString += "&";
                    }
                    if (_filter === "studyType") {
                        _filter = "study_type";
                    } else if (_filter === "studyTypeMethod") {
                        _filter = "study_type_method";
                    } else if (_filter === "deodorantFormat") {
                        _filter = "deodorant_format";
                    } else if (_filter === "studyPeriod") {
                        _filter = "study_period__title";
                    } else if (_filter === "unileverBrand") {
                        _filter = "unilever_brand";
                    } else if (_filter === "country") {
                        _filter = "country";
                    } else {
                        _filter = "";
                    }

                    queryString += _filter + "=" + checkedValue;
                }
            });
        }
        return queryString;
    };

    const checkMatchingNetAvailability = () => {
        const filterQueryString = getQueryString();
        let url = process.env.REACT_APP_SERVER_PATH + `/deodrants-match-net-analysis/exists/?archive=false&parsed=true&` + filterQueryString;
        try {
            api.get(url)
                .then(async (res) => {
                    setMatchingNetDataAvailable(res.data.has_data);
                })
                .catch(async (error) => {
                    handleError("error", error);
                });
        } catch (error) {
            handleError("error", error);
        }
    };

    useEffect(() => {
        if (!disableMoveIcon) {
            checkMatchingNetAvailability();
        } else {
            setMatchingNetDataAvailable(false);
        }
    }, [disableMoveIcon]);

    const getOptionsData = (data, identifier) => {
        let options = mapDataToOptions(data, true);
        if (identifier === "studyType") {
            options = options.sort((a, b) => b.label.localeCompare(a.label));
        } else if (identifier === "studyTypeMethod") {
            options = options.sort((a, b) => {
                // Sort by studyTypeTitle first
                if (a.studyTypeTitle < b.studyTypeTitle) return 1;
                if (a.studyTypeTitle > b.studyTypeTitle) return -1;

                // If studyTypeTitle is the same, sort by label alphabetically
                if (a.label < b.label) return -1;
                if (a.label > b.label) return 1;

                return 0;
            });
        }
        return options;
    };

    const handleRadioInputChange = (e) => {
        setSelectedContext(e.target.value);
    };

    const handleProceed = () => {
        dispatch(resetMatchNetStoreState());
        dispatch(loadSearchBarTextState(""));
        if (selectedContext === "Fragrance Testing Compatibility Context") {
            dispatch(loadSelectedStudyTypeState("fragrance_test"));
        } else {
            dispatch(loadSelectedStudyTypeState("home_use_test"));
        }
        setShowDialog(false);
        setOpenFilter(false);
        handleFiltersSubmit();
        navigateTo("/match-net");
    };

    const handleSelectAll = async (e) => {
        dispatch(loadSelectAllStudyFiltersFlagState(e.target.checked));
        if (e.target.checked) {
            const urls = {
                studyType: `${process.env.REACT_APP_SERVER_PATH}/core-data-models/study-type/?product_category=${productCategoryId}`,
                ...(isHairCare && {
                    "Blind/Branded/Full Mix": `${process.env.REACT_APP_SERVER_PATH}/study-datas/blind-branded/?product_category=${productCategoryId}&all=True`,
                    CBP: `${process.env.REACT_APP_SERVER_PATH}/study-datas/consumer-benefit-platform/?product_category=${productCategoryId}&all=True`,
                }),
                ...(isSkinCare && {
                    "Blind/Branded/Full Mix": `${process.env.REACT_APP_SERVER_PATH}/study-datas/blind-branded/?product_category=${productCategoryId}&all=True`,
                }),
                studyTypeMethod: `${process.env.REACT_APP_SERVER_PATH}/core-data-models/study-type-method/?product_category=${productCategoryId}&all=True`,
                country: `${process.env.REACT_APP_SERVER_PATH}/core-data-models/country/?product_category=${productCategoryId}&all=True`,
                unileverBrand: `${process.env.REACT_APP_SERVER_PATH}/core-data-models/unilever-brand/?product_category=${productCategoryId}&all=True`,
                deodorantFormat: `${process.env.REACT_APP_SERVER_PATH}/core-data-models/deodorant-format/?product_category=${productCategoryId}&all=True`,
                studyPeriod: `${process.env.REACT_APP_SERVER_PATH}/core-data-models/study-period/?product_category=${productCategoryId}&all=True`,
            };

            try {
                const responses = await Promise.all(
                    Object.entries(urls).map(([identifier, url]) =>
                        api
                            .get(url)
                            .then((res) => {
                                const options = getOptionsData(res.data, identifier);
                                return { [identifier]: options };
                            })
                            .catch((error) => {
                                handleError("error", error);
                                return null;
                            })
                    )
                );

                const data = Object.assign({}, ...responses);
                setFilterOptions((prev) => {
                    return {
                        ...prev,
                        ...data,
                    };
                });
                setFiltersValue((prev) => {
                    return {
                        ...prev,
                        ...data,
                    };
                });
                setSelectAllChecked({
                    studyType: true,
                    ...(isHairCare && { "Blind/Branded/Full Mix": true, CBP: true }),
                    ...(isSkinCare && { "Blind/Branded/Full Mix": true }),
                    studyTypeMethod: true,
                    country: true,
                    unileverBrand: true,
                    deodorantFormat: true,
                    studyPeriod: true,
                });
                setSelectedFilter("studyPeriod");
                dispatch(loadStudyPageFiltersState(data));
                dispatch(
                    loadStudyPageSelectAllFiltersState({
                        studyType: true,
                        ...(isHairCare && { "Blind/Branded/Full Mix": true, CBP: true }),
                        ...(isSkinCare && { "Blind/Branded/Full Mix": true }),
                        studyTypeMethod: true,
                        country: true,
                        unileverBrand: true,
                        deodorantFormat: true,
                        studyPeriod: true,
                    })
                );
            } catch (error) {
                handleError("error", error);
            }
        } else {
            setFilterOptions((prev) => ({
                ...prev,
                ...(isHairCare && {
                    "Blind/Branded/Full Mix": prev["Blind/Branded/Full Mix"].map((item) => ({ ...item, checked: false })),
                    CBP: prev.CBP.map((item) => ({ ...item, checked: false })),
                }),
                ...(isSkinCare && {
                    "Blind/Branded/Full Mix": prev["Blind/Branded/Full Mix"].map((item) => ({ ...item, checked: false })),
                }),
            }));
            setFiltersValue((prev) => {
                const values = prev.studyType.map((datum) => ({
                    ...datum,
                    checked: false,
                }));

                return {
                    studyType: values,
                    ...(isHairCare && {
                        "Blind/Branded/Full Mix": [],
                        CBP: [],
                    }),
                    ...(isSkinCare && {
                        "Blind/Branded/Full Mix": [],
                    }),
                    studyTypeMethod: [],
                    country: [],
                    unileverBrand: [],
                    deodorantFormat: [],
                    studyPeriod: [],
                };
            });
            setSelectAllChecked({
                studyType: false,
                ...(isHairCare && { "Blind/Branded/Full Mix": false, CBP: false }),
                ...(isSkinCare && { "Blind/Branded/Full Mix": false }),
                studyTypeMethod: false,
                country: false,
                unileverBrand: false,
                deodorantFormat: false,
                studyPeriod: false,
            });
            setSelectedFilter("studyType");
        }
    };

    const returnLabel = (identifier, ele) => {
        if (identifier === "studyTypeMethod") {
            const textColor = ele.studyTypeTitle === "Home Use Test" ? "#005eef" : "green";
            return (
                <Tooltip
                    title={ele.description}
                    placement="right"
                    componentsProps={{
                        tooltip: {
                            sx: {
                                fontSize: 9,
                            },
                        },
                    }}
                >
                    <span>{ele.label}</span>
                    <span style={{ color: textColor }}>{`(${ele.studyTypeTitle})`}</span>
                </Tooltip>
            );
        } else if (identifier === "country") {
            return (
                <>
                    <ReactCountryFlag
                        countryCode={ele.description}
                        svg
                        style={{
                            width: "1.5em",
                            height: "1.5em",
                            marginRight: "10px",
                        }}
                    />
                    <span>{ele.label}</span>
                </>
            );
        } else {
            return <span>{ele.label}</span>;
        }
    };

    const returnCheckBoxes = (ele, i, identifier) => {
        return (
            <FormControlLabel
                key={i}
                sx={{
                    "& .MuiTypography-root": {
                        fontSize: 12,
                        color: "#495057",
                        padding: 0,
                    },
                    borderRadius: "5px",
                    width: "100%",
                    margin: "3px 0px",
                    padding: "0px",
                    color: filtersValue[identifier][i]?.checked ? theme.palette.primary.main : theme.palette.text.primary,
                    background: filtersValue[identifier][i]?.checked ? "linear-gradient(270deg, rgb(0 103 239 / 0%) 0%, rgb(0 56 139 / 9%) 78%)" : "none",
                }}
                control={
                    <Checkbox
                        sx={{
                            "& .MuiSvgIcon-root": {
                                fontSize: 18,
                            },
                            padding: "6px",
                        }}
                        id={`${identifier}-${i}`}
                        checked={filtersValue[identifier][i]?.checked ? filtersValue[identifier][i]?.checked : false}
                        onChange={() => handleOnChange(identifier, i)}
                        value={ele.value}
                        name={`${identifier}-${i}`}
                    />
                }
                label={returnLabel(identifier, ele)}
            />
        );
    };

    const returnSelectAllAndClear = (label, identifier) => {
        return (
            <div
                className="px-2"
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    position: "sticky",
                }}
            >
                <div>
                    <FormControl
                        component="fieldset"
                        variant="standard"
                    >
                        <FormGroup>
                            <FormControlLabel
                                sx={{
                                    "& .MuiTypography-root": {
                                        fontSize: 12,
                                        color: "#495057",
                                    },
                                    borderRadius: "5px",
                                    width: "100%",
                                    margin: "3px 0px",
                                    padding: 0,
                                    color: selectAllChecked[identifier] ? theme.palette.primary.main : theme.palette.text.primary,
                                    background: selectAllChecked[identifier] ? "linear-gradient(270deg, rgb(0 103 239 / 0%) 0%, rgb(0 56 139 / 9%) 78%)" : "none",
                                }}
                                control={
                                    <Checkbox
                                        sx={{
                                            "& .MuiSvgIcon-root": {
                                                fontSize: 18,
                                            },
                                            padding: "6px",
                                        }}
                                        checked={selectAllChecked[identifier]}
                                        onChange={() => handleAllChecked(identifier, "allChecked")}
                                        name={`${identifier}-${label}`}
                                    />
                                }
                                label={label}
                            />
                        </FormGroup>
                    </FormControl>
                </div>
                <div>
                    <Button
                        size="small"
                        className="custom-btn-outlined color-blue"
                        variant="outlined"
                        style={{
                            padding: "0px 7px",
                            textTransform: "unset",
                            top: 4,
                            fontSize: 10,
                        }}
                        onClick={() => handleAllChecked(identifier, "clearAll")}
                    >
                        Clear All
                    </Button>
                </div>
            </div>
        );
    };

    const manageDependentFilters = (identifier) => {
        if (identifier === "studyType" && !filtersValue.studyType.some((ele) => ele.checked === true)) {
            const toReset = isBeautyAndWellbeing ? ["Blind/Branded/Full Mix", "CBP", "studyTypeMethod", "country", "unileverBrand", "deodorantFormat", "studyPeriod"] : ["studyTypeMethod", "country", "unileverBrand", "deodorantFormat", "studyPeriod"];
            handleClearDependentFilters(...toReset);
        } else if (isBeautyAndWellbeing && identifier === "Blind/Branded/Full Mix" && !filtersValue["Blind/Branded/Full Mix"].some((ele) => ele.checked === true)) {
            handleClearDependentFilters("CBP", "studyTypeMethod", "country", "unileverBrand", "deodorantFormat", "studyPeriod");
        } else if (isBeautyAndWellbeing && identifier === "CBP" && !filtersValue.CBP.some((ele) => ele.checked === true)) {
            handleClearDependentFilters("studyTypeMethod", "country", "unileverBrand", "deodorantFormat", "studyPeriod");
        } else if (identifier === "studyTypeMethod" && !filtersValue.studyTypeMethod.some((ele) => ele.checked === true)) {
            handleClearDependentFilters("country", "unileverBrand", "deodorantFormat", "studyPeriod");
        } else if (identifier === "country" && !filtersValue.country.some((ele) => ele.checked === true)) {
            handleClearDependentFilters("unileverBrand", "deodorantFormat", "studyPeriod");
        } else if (identifier === "unileverBrand" && !filtersValue.unileverBrand.some((ele) => ele.checked === true)) {
            handleClearDependentFilters("deodorantFormat", "studyPeriod");
        } else if (identifier === "deodorantFormat" && !filtersValue.deodorantFormat.some((ele) => ele.checked === true)) {
            handleClearDependentFilters("studyPeriod");
        }
    };

    const manageDependentFiltersForSelectAll = (identifier) => {
        if (identifier === "studyType" && filtersValue.studyType.every((ele) => ele.checked === false)) {
            const toReset = isBeautyAndWellbeing ? ["studyType", "Blind/Branded/Full Mix", "CBP", "studyTypeMethod", "country", "unileverBrand", "deodorantFormat", "studyPeriod"] : ["studyType", "studyTypeMethod", "country", "unileverBrand", "deodorantFormat", "studyPeriod"];
            handleClearDependentFilters(...toReset);
        } else if (isBeautyAndWellbeing && identifier === "Blind/Branded/Full Mix" && filtersValue["Blind/Branded/Full Mix"].every((ele) => ele.checked === false)) {
            handleClearDependentFilters("Blind/Branded/Full Mix", "CBP", "studyTypeMethod", "country", "unileverBrand", "deodorantFormat", "studyPeriod");
        } else if (isBeautyAndWellbeing && identifier === "CBP" && filtersValue.CBP.every((ele) => ele.checked === false)) {
            handleClearDependentFilters("CBP", "studyTypeMethod", "country", "unileverBrand", "deodorantFormat", "studyPeriod");
        } else if (identifier === "studyTypeMethod" && filtersValue.studyTypeMethod.every((ele) => ele.checked === false)) {
            handleClearDependentFilters("studyTypeMethod", "country", "unileverBrand", "deodorantFormat", "studyPeriod");
        } else if (identifier === "country" && filtersValue?.country.every((ele) => ele.checked === false)) {
            handleClearDependentFilters("country", "unileverBrand", "deodorantFormat", "studyPeriod");
        } else if (identifier === "unileverBrand" && filtersValue?.unileverBrand.every((ele) => ele.checked === false)) {
            handleClearDependentFilters("unileverBrand", "deodorantFormat", "studyPeriod");
        } else if (identifier === "deodorantFormat" && filtersValue?.deodorantFormat.every((ele) => ele.checked === false)) {
            handleClearDependentFilters("deodorantFormat", "studyPeriod");
        } else if (identifier === "studyPeriod" && filtersValue?.deodorantFormat.every((ele) => ele.checked === false)) {
            handleClearDependentFilters("studyPeriod");
        }
    };

    const fetchDependentFiltersData = (identifier) => {
      if (isHairCare) {
        if (identifier === "studyType") {
                fetchBlindBrandedFullMixData();
            } else if (identifier === "Blind/Branded/Full Mix") {
                fetchCBPData();
            } else if (identifier === "CBP") {
                fetchStudyTypeMethodData();
            } else if (identifier=== "studyTypeMethod") {
                fetchCountryData();
            } else if (identifier === "country") {
                fetchUnileverBrandData();
            } else if (identifier === "unileverBrand") {
                fetchDeodorantFormatData();
            } else if (identifier === "deodorantFormat") {
                fetchStudyPeriod();
            }
        } else if (isSkinCare) {
            if (identifier === "studyType") {
                fetchBlindBrandedFullMixData();
            } else if (identifier === "Blind/Branded/Full Mix") {
                fetchStudyTypeMethodData();
            } else if (identifier === "studyTypeMethod") {
                fetchCountryData();
            } else if (identifier === "country") {
                fetchUnileverBrandData();
            } else if (identifier === "unileverBrand") {
                fetchDeodorantFormatData();
            } else if (identifier === "deodorantFormat") {
                fetchStudyPeriod();
            }
        } else {  
        if (identifier === "studyType") {
            fetchStudyTypeMethodData();
        } else if (identifier === "studyTypeMethod") {
            fetchCountryData();
        } else if (identifier === "country") {
            fetchUnileverBrandData();
        } else if (identifier === "unileverBrand") {
            fetchDeodorantFormatData();
        } else if (identifier === "deodorantFormat") {
            fetchStudyPeriod();
        }
        }
    };

    const syncAllIdentifiersSelectAll = (latestFiltersValue) => {
        const updatedSelectAll = {};
        const updatedFiltersValue = { ...latestFiltersValue };
        Object.keys(filterOptions).forEach((identifier) => {
            const items = latestFiltersValue[identifier] || [];
            const isAllSelected = items.length > 0 && items.every((item) => item.checked === true);
            updatedSelectAll[identifier] = isAllSelected;
            if (isAllSelected) {
                updatedFiltersValue[identifier] = items.map((item) => ({
                    ...item,
                    checked: true,
                }));
            }
        });

        // Update both states
        setSelectAllChecked({ ...updatedSelectAll });
        setFiltersValue({ ...updatedFiltersValue });

        // Update redux
        dispatch(loadStudyPageSelectAllFiltersState({ ...updatedSelectAll }));
        dispatch(loadStudyPageFiltersState({ ...updatedFiltersValue }));
    };

    const handleOnChange = (identifier, i) => {
        let datum = filtersValue;
        //if the value of the passed position parameter matches with the current index, then we reverse its value. Then, if the value is true it will be converted to false using !item and if the value is false, then it will be converted to true.
        const updatedCheckedState = isBeautyAndWellbeing
            ? (filtersValue[identifier]?.length > 0 ? filtersValue[identifier] : filterOptions[identifier])?.map((item, index) => {
                  if (index === i) {
                      return { ...item, checked: !item.checked };
                  }
                  return item;
              })
            : filtersValue[identifier]?.map((item, index) => {
            if (index === i) {
                return { ...item, checked: !item.checked };
            }
            return item;
        });

        datum[identifier] = updatedCheckedState;
        
        //  Clear dependent filter before API call
        if (identifier === "Blind/Branded/Full Mix") {
            datum.CBP = [];
            setFilterOptions((prev) => ({
                ...prev,
                CBP: [],
            }));
        }
        setFiltersValue((pre) => {
            return { ...pre, ...datum };
        });

        // logic to handle select all if every filters are checked one by one
        // looping over updatedCheckedState to check if every filter is selected or not to handle select all
        let obj = selectAllChecked;
        if (!updatedCheckedState.some((ele) => ele.checked === false)) {
            obj[identifier] = true;
        } else {
            obj[identifier] = false;
        }
        setSelectAllChecked({ ...obj });

        manageDependentFilters(identifier);

        dispatch(loadStudyPageFiltersState({ ...datum }));
        dispatch(loadStudyPageSelectAllFiltersState({ ...obj }));

        fetchDependentFiltersData(identifier);
    };

    const handleAllChecked = (identifier, eventName) => {
        let obj = selectAllChecked;
        if (eventName === "allChecked") {
            obj[identifier] = !obj[identifier];

            //handle every filters checkbox
            const temp = filtersValue[identifier]?.map((datum) => {
                return {
                    description: datum.description,
                    value: datum.value,
                    label: datum.label,
                    checked: obj[identifier],
                };
            });
            let datum = filtersValue;
            datum[identifier] = [...temp];
            setFiltersValue((pre) => {
                return {
                    ...pre,
                    ...datum,
                };
            });

            // updating studyPageFilters global data
            dispatch(loadStudyPageFiltersState({ ...filtersValue, ...datum }));

            setSelectAllChecked({ ...obj });
            // Select all ----- updating studyPageSelectAllFilters global data
            dispatch(loadStudyPageSelectAllFiltersState({ ...obj }));

            if (obj[identifier] === false) {
                manageDependentFiltersForSelectAll(identifier);
            }
        } else if (eventName === "clearAll") {
            obj[identifier] = false;

            // //       // clear every filters checkbox
            const temp = filtersValue[identifier]?.map((datum) => {
                return {
                    description: datum.description,
                    value: datum.value,
                    label: datum.label,
                    checked: false,
                };
            });

            let datum = filtersValue;
            datum[identifier] = [...temp];
            setFiltersValue((pre) => {
                return {
                    ...pre,
                    ...datum,
                };
            });

            // updating studyPageFilters global data
            setSelectAllChecked({ ...obj });
            dispatch(loadStudyPageFiltersState({ ...datum }));

            // Select all ----- updating studyPageSelectAllFilters global data
            dispatch(loadStudyPageSelectAllFiltersState({ ...obj }));

            manageDependentFiltersForSelectAll(identifier);
        }

        fetchDependentFiltersData(identifier);
    };

    const handleClearDependentFilters = (...identifiers) => {
        identifiers.forEach((identifier) => {
            let datum = filtersValue;
            const updatedCheckedState = filtersValue[identifier]?.map((item) => {
                return { ...item, checked: false };
            });
            datum[identifier] = updatedCheckedState;
            setFiltersValue((pre) => {
                return { ...pre, ...datum };
            });

            // updating studyPageFilters global data
            dispatch(loadStudyPageFiltersState({ ...datum }));

            let obj = selectAllChecked;
            obj[identifier] = false;

            setSelectAllChecked({ ...obj });

            dispatch(loadStudyPageSelectAllFiltersState({ ...obj }));

            fetchDependentFiltersData(identifier);
        });
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    const getFilterLabelClassName = (selectedFilter, ele, enableFilter) => {
        let className = "box-shadow--full-container";
        if (selectedFilter === ele.value) {
            className += " remove-opacity ";
        } else if (enableFilter[ele.value]) {
            className += " enable-filter ";
        }
        return className;
    };

    const renderFilterSection = (filterKey) => {
        const options = filterOptions[filterKey] || [];
        if (selectedFilter !== filterKey) return null;

        return (
            <>
                {options.length > 0 && returnSelectAllAndClear("Select All", filterKey)}
                <div
                    className="px-3"
                    style={{
                        overflowY: "auto",
                        minHeight: "calc(100vh - 236px)",
                        height: "calc(100vh - 236px)",
                    }}
                >
                    <FormGroup>{filtersValue && options.map((ele, i) => returnCheckBoxes(ele, i, filterKey))}</FormGroup>
                </div>
            </>
        );
    };

    return (
        <>
            <button
                className="mb-0 liner-light-blue-background color-white text-bold-6"
                style={{
                    cursor: "pointer",
                    fontSize: "12px",
                    color: "#4d4d4d",
                    borderRadius: "5px 0px 0px 5px  ",
                    padding: "8px 12px",
                    zIndex: 5,
                    outline: "none",
                    border: "none",
                }}
                onClick={toggleDrawer("left", !openFilter)}
            >
                <TuneIcon
                    fontSize="small"
                    className="px-0 m-0"
                />
            </button>
            <Drawer
                sx={{
                    minWidth: 360,
                    height: "calc(100% - 145px)",
                    position: "unset",
                    flexShrink: 0,

                    "& .MuiDrawer-paper": {
                        minWidth: 360,
                        maxHeight: "calc(100% - 145px)",
                        boxSizing: "border-box",
                        top: 124,
                        left: 24,
                        borderRadius: "5px",
                    },
                }}
                anchor={"left"}
                open={openFilter}
                // hideBackdrop={true}
                ModalProps={{
                    BackdropProps: {
                        sx: {
                            zIndex: 2,
                            width: "100%",
                            height: "calc(100vh - 55px)",
                            marginTop: "56px",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                        },
                    },
                }}
            >
                <Box
                    role="paper"
                    onKeyDown={toggleDrawer("left", false)}
                >
                    <div
                        className="filter-box "
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            overflow: "hidden",
                        }}
                    >
                        <div
                            className="filter-key-box liner-light-blue-background"
                            style={{
                                width: "160px",
                                minHeight: "calc(100vh - 145px)",
                                height: "calc(100vh - 145px)",
                                overflowY: "auto",
                            }}
                        >
                            <div>
                                <FormControl
                                    component="fieldset"
                                    variant="standard"
                                >
                                    <FormGroup>
                                        <FormControlLabel
                                            sx={{
                                                "& .MuiTypography-root": {
                                                    fontSize: 14,
                                                    color: "#FFFFFF",
                                                },
                                                borderRadius: "5px",
                                                width: "100%",
                                                margin: "6px 0px -6px 0px",
                                                padding: 0,
                                                color: "#FFFFFF",
                                            }}
                                            control={
                                                <Checkbox
                                                    checked={selectAllStudyFiltersFlag}
                                                    sx={{
                                                        color: "white",
                                                        "&.Mui-checked": {
                                                            color: "white",
                                                        },
                                                        "& .MuiSvgIcon-root": {
                                                            fontSize: 20,
                                                        },
                                                        padding: "4px 6px 6px 20px",
                                                    }}
                                                    onChange={(e) => handleSelectAll(e)}
                                                />
                                            }
                                            label="Select All"
                                        />
                                    </FormGroup>
                                </FormControl>
                            </div>
                            {filtersValue &&
                                filtersLabel?.map((ele) => {
                                    const enableFilter = {
                                        // productCategory: true,
                                        studyType: true,
                                        "Blind/Branded/Full Mix": false,
                                        CBP: false,
                                        studyTypeMethod: false,
                                        country: false,
                                        deodorantFormat: false,
                                        unileverBrand: false,
                                        studyPeriod: false,
                                    };
                                    if (isHairCare) {
                                        if (filtersValue.studyType?.some((ele) => ele.checked)) {
                                            enableFilter["Blind/Branded/Full Mix"] = true;
                                        }
                                        if (filtersValue.studyType?.some((ele) => ele.checked) && filtersValue["Blind/Branded/Full Mix"]?.some((ele) => ele.checked)) {
                                            enableFilter.CBP = true;
                                        }
                                        if (filtersValue.studyType?.some((ele) => ele.checked) && filtersValue["Blind/Branded/Full Mix"]?.some((ele) => ele.checked) && filtersValue.CBP?.some((ele) => ele.checked)) {
                                            enableFilter.studyTypeMethod = true;
                                        }
                                        if (filtersValue.studyTypeMethod?.some((ele) => ele.checked)) {
                                            enableFilter.country = true;
                                        }
                                        if (filtersValue.country?.some((ele) => ele.checked)) {
                                            enableFilter.unileverBrand = true;
                                        }
                                        if (filtersValue.unileverBrand?.some((ele) => ele.checked)) {
                                            enableFilter.deodorantFormat = true;
                                        }
                                        if (filtersValue.deodorantFormat?.some((ele) => ele.checked)) {
                                            enableFilter.studyPeriod = true;
                                        }
                                    } else if (isSkinCare) {
                                        if (filtersValue.studyType?.some((ele) => ele.checked)) {
                                            enableFilter["Blind/Branded/Full Mix"] = true;
                                        }
                                        if (filtersValue.studyType?.some((ele) => ele.checked) && filtersValue["Blind/Branded/Full Mix"]?.some((ele) => ele.checked)) {
                                            enableFilter.studyTypeMethod = true;
                                        }
                                        if (filtersValue.studyTypeMethod?.some((ele) => ele.checked)) {
                                            enableFilter.country = true;
                                        }
                                        if (filtersValue.country?.some((ele) => ele.checked)) {
                                            enableFilter.unileverBrand = true;
                                        }
                                        if (filtersValue.unileverBrand?.some((ele) => ele.checked)) {
                                            enableFilter.deodorantFormat = true;
                                        }
                                        if (filtersValue.deodorantFormat?.some((ele) => ele.checked)) {
                                            enableFilter.studyPeriod = true;
                                        }
                                    } else {
                                         if (filtersValue?.studyType.some((ele) => ele.checked)) {
                                            enableFilter.studyTypeMethod = true;
                                }
                                    if (filtersValue?.studyTypeMethod.some((ele) => ele.checked) && filtersValue.studyType.some((ele) => ele.checked)) {
                                        enableFilter.country = true;
                                    }
                                    if (filtersValue?.country.some((ele) => ele.checked === true) && filtersValue?.studyTypeMethod.some((ele) => ele.checked === true) && filtersValue.studyType.some((ele) => ele.checked === true)) {
                                        enableFilter.unileverBrand = true;
                                    }
                                    if (filtersValue?.unileverBrand.some((ele) => ele.checked === true) && filtersValue.country.some((ele) => ele.checked === true) && filtersValue?.studyTypeMethod.some((ele) => ele.checked === true) && filtersValue.studyType.some((ele) => ele.checked === true)) {
                                        enableFilter.deodorantFormat = true;
                                    }
                                    if (
                                        filtersValue?.deodorantFormat.some((ele) => ele.checked === true) &&
                                        filtersValue?.unileverBrand.some((ele) => ele.checked === true) &&
                                        filtersValue?.country.some((ele) => ele.checked === true) &&
                                        filtersValue?.studyTypeMethod.some((ele) => ele.checked === true) &&
                                        filtersValue.studyType.some((ele) => ele.checked === true)
                                    ) {
                                        enableFilter.studyPeriod = true;
                                    }
                                    }
                                    const isHidden = (!isBeautyAndWellbeing && (ele.value === "Blind/Branded/Full Mix" || ele.value === "CBP")) || (isSkinCare && ele.value === "CBP");
                                    return (
                                        <button
                                            key={ele.value}
                                            style={{
                                                display: isHidden ? "none" : undefined,
                                                backgroundColor: "#FFFFFF",
                                                padding: "5px",
                                                color: "#005eef",
                                                borderRadius: "5px",
                                                fontSize: "12px",
                                                fontWeight: "600",
                                                marginTop: "20px",
                                            }}
                                            // className={selectedFilter === ele.value ? "remove-opacity box-shadow--full-container" : enableFilter[ele.value] ? "enable-filter box-shadow--full-container" : "box-shadow--full-container"}
                                            className={getFilterLabelClassName(selectedFilter, ele, enableFilter)}
                                            onClick={() => setSelectedFilter(ele.value)}
                                        >
                                            <div className={selectedFilter === ele.value ? "box-shadow--2 filter-img-box" : "filter-img-box "}>
                                                <img
                                                    src={ele.image}
                                                    alt={ele.value}
                                                    style={{
                                                        width: "110px",
                                                        height: "70px",
                                                    }}
                                                />
                                            </div>
                                            <span
                                                className="text-xxs"
                                                style={{
                                                    textShadow: "rgb(255, 255, 255) 0px 0px 10px, rgba(255, 71, 217, 0) 11px -1px 12px",
                                                }}
                                            >
                                                {isSkinCare && ele.value === "Blind/Branded/Full Mix" ? "Blind/Branded" : ele.label}
                                            </span>
                                        </button>
                                    );
                                })}
                        </div>
                        <div
                            className="filter-value-box pt-2 pb-0 px-0"
                            style={{
                                maxWidth: "200px",
                                minWidth: "200px",
                                width: "200px",
                                minHeight: "calc(100vh - 145px)",
                                height: "calc(100vh - 145px)",
                            }}
                        >
                            {Object.keys(filterOptions).map((filterKey) => renderFilterSection(filterKey))}

                            {isDeodorants ? (
                                <>
                                    <style>
                                        {`
                                            .navigation-wrapper {
                                                position: relative;
                                                width: 192px;
                                                height: 52px;
                                            }

                                            .svg-wrapper {
                                                position: absolute;
                                                inset: 0;
                                                display: flex;
                                                justify-content: center;
                                                align-items: center;
                                                z-index: 2;
                                            }

                                            .buttons {
                                                position: absolute;
                                                left: 50%;
                                                top: 50%;
                                                transform: translate(-50%, -35%);
                                                z-index: 1;
                                            }

                                            .button {
                                                background: transparent;
                                                position: absolute;
                                                border: none;
                                                transition: 0.5s;
                                                border-radius: 10px;
                                            }

                                            .button span {
                                                display: none;
                                            }

                                            .navigation-wrapper:hover .button span {
                                                display: block;
                                            }

                                            .button:hover:not(:disabled) {
                                                transform: scale(1.15);
                                            }

                                            .button:disabled {
                                                cursor: not-allowed;
                                            }

                                            .navigation-wrapper:hover .button-position-0 {
                                                translate: -35px -55px;
                                            }

                                            .navigation-wrapper:hover .button-position-1 {
                                                translate: 35px -55px;
                                            }

                                            .main-button-wrapper {
                                                position: absolute;
                                                left: 50%;
                                                top: 50%;
                                                transform: translate(-50%, -35%);
                                                z-index: 3;
                                            }

                                            .main-button {
                                                border: none;
                                                background: transparent;
                                                padding: 0;
                                                cursor: pointer;
                                            }
                                        `}
                                    </style>
                                    <div className="navigation-wrapper">
                                        <div className="buttons">
                                            <button
                                                className="button-position-0 button"
                                                style={{
                                                    transitionProperty: "translate",
                                                }}
                                                onClick={handleFilters}
                                                disabled={disableMoveIcon}
                                            >
                                                <IconButton
                                                    className={disableMoveIcon ? undefined : "liner-light-blue-background"}
                                                    size="small"
                                                    disabled={disableMoveIcon}
                                                    style={{
                                                        padding: "4px",
                                                        background: disableMoveIcon ? "#D8D8D8" : undefined,
                                                    }}
                                                >
                                                    <img
                                                        src={moveIcon}
                                                        alt="move"
                                                        style={{
                                                            width: 34,
                                                            height: 34,
                                                            objectFit: "contain",
                                                        }}
                                                    />
                                                </IconButton>

                                                <span
                                                    style={{
                                                        fontSize: "9px",
                                                        whiteSpace: "nowrap",
                                                    }}
                                                >
                                                    Studies
                                                </span>
                                            </button>
                                            <Tooltip
                                                title={!matchingNetDataAvailable ? "No matching products have been identified based on the selected metadata and filtering criteria." : ""}
                                                placement="top-start"
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            bgcolor: "#F5F5F5",
                                                            color: "#000",
                                                            maxWidth: 210,
                                                            border: "1px solid #F5F5F5",
                                                            boxShadow: 2,
                                                        },
                                                    },
                                                    arrow: {
                                                        sx: {
                                                            color: "#F5F5F5",
                                                        },
                                                    },
                                                    popper: {
                                                        modifiers: [
                                                            {
                                                                name: "offset",
                                                                options: {
                                                                    offset: [0, -7],
                                                                },
                                                            },
                                                        ],
                                                    },
                                                }}
                                            >
                                                <button
                                                    className="button-position-1 button"
                                                    style={{
                                                        transitionProperty: "translate",
                                                    }}
                                                    onClick={() => handleDialogToggle()}
                                                    disabled={!matchingNetDataAvailable}
                                                    // title={!matchingNetDataAvailable ? "No matching products have been identified based on the selected metadata and filtering criteria" : ""}
                                                >
                                                    <IconButton
                                                        className={!matchingNetDataAvailable ? undefined : "liner-light-blue-background"}
                                                        size="small"
                                                        disabled={!matchingNetDataAvailable}
                                                        style={{
                                                            padding: "4px",
                                                            background: !matchingNetDataAvailable ? "#D8D8D8" : undefined,
                                                        }}
                                                    >
                                                        <img
                                                            src={matchNet}
                                                            alt="match-net"
                                                            style={{
                                                                width: 34,
                                                                height: 34,
                                                                objectFit: "contain",
                                                            }}
                                                        />
                                                    </IconButton>

                                                    <span
                                                        style={{
                                                            fontSize: "9px",
                                                            whiteSpace: "nowrap",
                                                        }}
                                                    >
                                                        MatchNet
                                                    </span>
                                                </button>
                                            </Tooltip>
                                        </div>
                                        <div className="svg-wrapper">
                                            <svg
                                                width="162"
                                                height="52"
                                                viewBox="0 0 152 42"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <defs>
                                                    <linearGradient
                                                        id="gradient"
                                                        x1="0%"
                                                        y1="0%"
                                                        x2="100%"
                                                        y2="0%"
                                                    >
                                                        <stop
                                                            offset="0%"
                                                            style={{
                                                                stopColor: "rgba(71, 163, 255, 1)",
                                                                stopOpacity: 1,
                                                            }}
                                                        />
                                                        <stop
                                                            offset="100%"
                                                            style={{
                                                                stopColor: "rgba(0, 94, 239, 1)",
                                                                stopOpacity: 1,
                                                            }}
                                                        />
                                                    </linearGradient>
                                                </defs>

                                                <path
                                                    d="M0 41.0513C7.62 39.6013 15 37.6613 22.1 34.6813C31.01 30.9413 38.63 25.4313 45.1 18.2913C47.73 15.3913 50.36 12.4913 53.06 9.66128C58.66 3.81128 65.59 0.611281 73.63 0.081281C83.13 -0.548719 91.42 2.48128 98.19 9.25128C101.28 12.3413 104.18 15.6213 107.12 18.8613C116.51 29.1813 128.31 35.3313 141.66 38.7713C144.96 39.6213 148.28 40.3513 151.25 41.0613C101.12 41.0513 50.62 41.0513 0 41.0513Z"
                                                    fill="url(#gradient)"
                                                />
                                            </svg>
                                        </div>
                                        <div className="main-button-wrapper">
                                            <button className="main-button">
                                                <AutoGraphRoundedIcon
                                                    sx={{
                                                        color: "#fff",
                                                        fontSize: 24,
                                                    }}
                                                />
                                            </button>
                                        </div>
                                    </div>
                                </>                                
                            ) : (
                                <div
                                    className={disableMoveIcon ? "move-button--hidden" : "move-button--visible"}
                                    style={{
                                        width: 220,
                                        display: "block",
                                        margin: "0px auto",
                                    }}
                                >
                                    <button
                                        className="px-2 py-1"
                                        style={{
                                            position: "absolute",
                                            right: 65,
                                            bottom: 0,
                                            cursor: "pointer",
                                            width: 50,
                                            height: 35,
                                            border: "none",
                                            outline: "none",
                                            backgroundColor: "transparent",
                                        }}
                                        onClick={handleFilters}
                                    >
                                        <img
                                            style={{
                                                width: 30,
                                                height: 25,
                                                color: "white",

                                                filter: "brightness(0) invert(1)",
                                            }}
                                            src={forwardPng}
                                            alt={"forward"}
                                        />
                                    </button>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 1440 320"
                                    >
                                        <defs>
                                            <linearGradient
                                                id="gradient"
                                                x1="0%"
                                                y1="0%"
                                                x2="100%"
                                                y2="0%"
                                            >
                                                <stop
                                                    offset="0%"
                                                    style={{
                                                        stopColor: "rgba(71, 163, 255, 1)",
                                                        stopOpacity: 1,
                                                    }}
                                                />
                                                <stop
                                                    offset="100%"
                                                    style={{
                                                        stopColor: "rgba(0, 94, 239, 1)",
                                                        stopOpacity: 1,
                                                    }}
                                                />
                                            </linearGradient>
                                        </defs>
                                        <path
                                            fill="url(#gradient)"
                                            fillOpacity="1"
                                            d="M0,288L60,288C120,288,240,288,360,250.7C480,213,600,139,720,101.3C840,64,960,64,1080,106.7C1200,149,1320,235,1380,277.3L1440,320L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
                                        />
                                    </svg>
                                </div> 
                            )}                        
                        </div>
                    </div>
                </Box>
            </Drawer>
            {showDialog && (
                <Dialog
                    open={showDialog}
                    onClose={handleDialogToggle}
                    sx={{ "& .MuiDialog-paper": { width: "700px", maxWidth: "700px", minHeight: 200, maxHeight: 200 } }}
                    fullWidth
                >
                    <DialogTitle
                        style={{
                            backgroundColor: "rgb(51, 94, 234,0.1)",
                            color: "rgb(51, 94, 234)",
                            fontSize: 15,
                            textAlign: "center",
                            padding: "10px 12px",
                        }}
                        id="dialog-title"
                    >
                        PLEASE SELECT THE CONTEXT TO PROCEED MATCHNET
                        <IconButton
                            aria-label="close"
                            sx={{
                                position: "absolute",
                                right: 8,
                                top: 2,
                                color: "rgb(51, 94, 234) !important",
                            }}
                            onClick={handleDialogToggle}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent sx={{ py: 2, px: 4 }}>
                        <FormControl sx={{ width: "100%" }}>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                value={selectedContext}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    marginTop: "36px",
                                }}
                            >
                                {["Home Use Test Compatibility Context", "Fragrance Testing Compatibility Context"].map((ele) => {
                                    return (
                                        <FormControlLabel
                                            key={ele}
                                            sx={{
                                                marginRight: "12px",
                                                marginLeft: "12px",
                                                "& .MuiTypography-root": {
                                                    fontSize: 12,
                                                    color: "#969696",
                                                },
                                                borderRadius: "5px",
                                            }}
                                            value={ele}
                                            control={
                                                <Radio
                                                    onChange={(e) => handleRadioInputChange(e)}
                                                    value={ele}
                                                    checked={selectedContext === ele}
                                                    sx={{
                                                        "& .MuiSvgIcon-root": {
                                                            fontSize: 16,
                                                            color: "#969696",
                                                        },
                                                        "& .MuiSvgIcon-root:nth-of-type(2)": {
                                                            fontSize: 16,
                                                            color: "#1976d2",
                                                        },
                                                    }}
                                                />
                                            }
                                            label={ele}
                                        />
                                    );
                                })}
                            </RadioGroup>
                        </FormControl>
                    </DialogContent>
                    <DialogActions
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "16px",
                            width: "100%",
                            marginBottom: "16px",
                        }}
                    >
                        <Button
                            autoFocus
                            size="small"
                            className={selectedContext === "" ? "custom-btn custom-btn--upload-reset disabled" : "custom-btn custom-btn--upload-reset"}
                            variant="outlined"
                            onClick={handleProceed}
                            disabled={selectedContext === ""}
                        >
                            Proceed
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}

StudiesFiltersComponent.propTypes = {
    handleFiltersSubmit: PropTypes.func,
    studiesRoute: PropTypes.string,
    defaultOpen: PropTypes.bool,
};

export default StudiesFiltersComponent;
